import Modal from '../../components/Modal';
import { ImageSizes } from '../../components/ProductMediaGallery';
import { ResponsiveProductImage } from '../../components/ResponsiveProductImage';
import { OfferTypes, ProductViewModel } from '../../types/generated';
import { OfferDetails } from './Offer';

export interface OffersModalProps {
  offer: OfferDetails;
  showModal: boolean;
  updateShowModal: (data: boolean) => void;
  freeProduct: ProductViewModel | null;
}

export default function OfferModal({
  offer,
  showModal,
  updateShowModal,
  freeProduct
}: OffersModalProps) {
  const fallbackImage =
    'https://cdn.images.fecom-media.com/image_coming_soon.jpg';

  const imageSizes: ImageSizes = {
    xs: 70,
    // sm: 480,
    // md: 270,
    lg: 183
    // xl: 445,
  };

  return (
    offer && (
      <Modal
        //style={previewModalStyles}
        className="modal-md modal-dialog-scrollable"
        title={offer.offerTypeName || 'Available Offer'}
        isVisible={showModal}
        showClose={true}
        handleClose={() => updateShowModal(false)}
        escapeToClose={true}
      >
        <ul className="list-unstyled pl-3 mb-0">
          {offer.offerTypeName === OfferTypes.FreeProduct && freeProduct ? (
            <li key={offer.productCatalogueRef} className="pt-3">
              <div className="row mb-3">
                <div className="col text-center">{offer.offerDescription}</div>
              </div>
              <div className="row">
                <div className="col-6 mx-auto">
                  <ResponsiveProductImage
                    src={freeProduct.imageUrl || fallbackImage}
                    {...imageSizes}
                  />
                  <div className="text-center">
                    <a href={freeProduct.urlPath || ''}>
                      <small>{freeProduct.name}</small>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          ) : (
            <li key={offer.productCatalogueRef} className="pt-3">
              <div className="col text-center">{offer.offerDescription}</div>
            </li>
          )}
        </ul>
      </Modal>
    )
  );
}
